

export const DOT = "·";

export function now() {
    return new Date().getTime();
}

export function groupByFunction(arr, fun) {
    const groupByVersion = {}
    arr.forEach(r => {
        const grp = fun(r)
        if (!groupByVersion[grp]) {
            groupByVersion[grp] = []
        }
        groupByVersion[grp].push(r)
    })
    return groupByVersion
}
export function group(arr, field) {
    return groupByFunction(arr, r => r[field])
}

export function sortStringFieldName(item1, item2) {
    if (item1['name'] < item2['name'])
        return -1;
    if (item1['name'] > item2['name'])
        return 1;
    return 0;
}

export function sortString(item1, item2) {
    if (item1 < item2)
        return -1;
    if (item1 > item2)
        return 1;
    return 0;
}

export function distinct(arr) {
    return [...new Set(arr)]
}

export function filterByName(name) {
    const filter = name.toLowerCase().trim()
    return (el) => {
        if (!name || !el.name) {
            return true;
        }
        return el.name.toLowerCase().trim().includes(filter)
    }
}

export function newID(length = 8) {
    return Math.random().toString(36).substring(2, length + 2);
}